import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section-shell pt-16">
      <div className="mx-auto max-w-2xl surface-panel p-10 text-center">
        <div className="eyebrow-light">404</div>
        <h1 className="mt-4 font-display text-4xl font-bold text-ink">Page not found</h1>
        <p className="mt-4 text-slate-600">
          The page you requested does not exist in this Dreameer Education build.
        </p>
        <Link to="/" className="button-primary mt-8">
          Go home
        </Link>
      </div>
    </section>
  );
}
